export class ComponentOptionModel {
  actions: any;
  methods: any;
  data: any;
}
